export const percentPrice = (price, count, percent, setAllTotalPrice) => {
  const total = +price * +count;
  const result = (total * percent) / 100;

  if (percent !== 0) {
    const totalCount = total - result;
    return +totalCount;
  } else {
    return +total;
  }
};
